import type { ReceiptBatchFormValues } from '../interfaces/ReceiptBatchFormValues';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const transformReceiptBatchFormValuesForUpdate = (
  batchId: string,
  globalServiceProviderId: string,
  values: ReceiptBatchFormValues
) => {
  return {
    batchId: batchId,
    title: 'Deprecated',
    receiptDate: values.receiptDate as Date,
    nursingHomeId: values.nursingHomeId as string,
    receiptImageIds: values.batchImageIds,
    globalServiceProviderId: globalServiceProviderId,
    generateReceipts: values.generateReceipts,
    receiptBatchEntries: values.receipts.map((receipt) => {
      return {
        ...receipt,
        id: receipt.id?.startsWith('new') ? undefined : receipt.id,
        receiptImageIds: receipt.receiptImageIds
          ? receipt.receiptImageIds
          : undefined,
        // If line items are not enabled, we only submit the amount and notes and let the backend handle the conversion
        lineItems: receipt.lineItems?.map((lineItem) => ({
          id: lineItem.id,
          count: 1,
          name: lineItem.name,
          amountPerItemInCent: lineItem.amount ?? 0,
          taxes: lineItem.taxes?.map((tax) => ({
            taxAmount: tax.taxAmount,
            countryId: tax.countryId,
            taxName: tax.taxName,
            explanationShort: tax.explanationShort,
            explanationLong: tax.explanationLong,
            displayExplanation: tax.displayExplanation,
          })),
        })),
      };
    }),
  };
};
